import { actionTypes } from '../constants';

export const searchChanged = (value) => ({
  type: actionTypes.relatedRoomsSearchChanged,
  payload: value,
});
